<template>
  <div v-if="$route.path !== '/login'" class="col-4 text-right login-status">
    <div v-if="loggedIn && this.user_name !== undefined" >
      <div :class="org">
        <span class="mt-4"><strong>Welcome, {{ user_name }}</strong></span>
        <!-- <strong><router-link class="pt-4" to="/profile">My Profile</router-link></strong></p> -->
        <button class="ml-2 btn btn-primary login-button" @click="submitSignOut">Logout</button>
      </div>
    </div>
    <div v-else-if="loggedIn && this.user_name == undefined">
      <div :class="org">
        <span class="mt-4"><strong>Welcome!</strong></span>
        <button class="ml-2 btn btn-primary login-button" @click="submitSignOut">Logout</button>
      </div>
    </div>
    <div v-else>
      <div :class="org">
        <span>Welcome!</span>
        <router-link class="login-link" to="/login">
          <button class="ml-2 btn btn-primary login-button">Login</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../auth.js'
export default {
  data(){
    return {
      loggedIn: "false",
      user_name: '',
      org: this.$route.params.organization_name
    }
  },
  mounted(){
    this.$store.watch( (state, getters) => {
      this.loggedIn = getters.loginStatus
    }),
    this.getUserName()
  },
  onIdle(){
    if (this.loggedIn) {
      axios.delete(
        `${process.env.VUE_APP_ENDPOINT}/users/sign_out/`,
        {}
      ).then(()=>{
        localStorage.setItem("loggedIn", false)
        localStorage.setItem("user_name", null)
        this.$store.commit('login', false)
        this.$store.commit('setUserName', null)
        var route = window.location.pathname.split('/')
        route.pop()
        var new_route = route.join('/') + "/information"
        this.$router.push(new_route)
      }).catch(
        e => { this.message = e }
      )
    }
  },
  methods:{
    submitSignOut(){
      event.preventDefault()
      axios.delete(
        `${process.env.VUE_APP_ENDPOINT}/users/sign_out/`,
        {}
      ).then(()=>{
        localStorage.setItem("loggedIn", false)
        localStorage.setItem("user_name", null)
        this.$store.commit('login', false)
        this.$store.commit('setUserName', null)
        var route = window.location.pathname.split('/')
        route.pop()
        var new_route = route.join('/') + "/information"
        this.$router.push(new_route)
      }).catch(
        e => { this.message = e }
      )
    },
    getUserName(){
      if(localStorage.user_name == 'null'){
        localStorage.setItem("user_name", this.$store.getters.getUserName)
        this.user_name = localStorage.user_name
      } else {
        this.user_name = localStorage.user_name
      }
    }
  }
}
</script>

<style scoped>

.login-button {
  margin-right: 3em;
  color: #bfbfbf !important;
  border: 2px solid #bfbfbf !important;
}

.login-button:hover {
  margin-right: 3em;
  color: #9f9f9f !important;
  border: 2px solid #9f9f9f !important;
}

.login-status {
  margin-top: 3em;
  color: #bfbfbf;
}

</style>
